import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import DashboardLayout from './layouts/DashboardLayout'
import AuthLoadingScreen from './AuthLoadingScreen'

const ProtectedLayout = () => {
  const { isAuthenticated, isAuthenticating } = useAuthStore()
  
  // Show loading screen during authentication process
  if (isAuthenticating) {
    return <AuthLoadingScreen />
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />
  }
  
  return <DashboardLayout />
}

export default ProtectedLayout